import { forwardRef } from "react";
import Form from "react-bootstrap/Form";
import { logDev } from "src/utils";

type TProps = {
    // NOSONAR
    label: string | React.ReactNode; // NOSONAR
} & any; // NOSONAR

const LobbieCheckbox = forwardRef((props: TProps, ref: React.Ref<any>) => {
    const { label, style, checkmarkStyle, setValue, value, name, ...rest } = props;

    // When NOT using react-hook-form
    if (!setValue) {
        return (
            <Form.Label
                className={`checkbox-container ${rest.className || ""}`}
                style={{
                    ...style,
                    opacity: rest.disabled ? "50%" : "100%",
                }}
                data-disabled={rest.disabled ? true : undefined}
            >
                <input
                    {...rest}
                    ref={ref}
                    name={name}
                    className={"lobbie-checkbox"}
                    type={"checkbox"}
                    disabled={rest.disabled ? true : undefined}
                />
                <span
                    className="checkmark"
                    data-disabled={rest.disabled ? true : undefined}
                    style={checkmarkStyle}
                ></span>
                {typeof label === "string" || typeof label === "number" ? (
                    <span
                        className="cy-checkmark-label"
                        data-disabled={rest.disabled ? true : undefined}
                    >
                        {label}
                    </span>
                ) : (
                    label
                )}
            </Form.Label>
        );
    }

    if (["string", "number", "object"].includes(typeof value)) {
        logDev(
            "LobbieCheckbox - `value` prop sent to LobbieCheckbox is non-boolean. Skip render. Value -",
            value,
        );
        if (typeof value === "object") {
            logDev("LobbieCheckbox - value is a typeof object. Return null.");
            return null;
        }
    }

    const handleSetChecked = () => {
        if (rest.disabled) {
            logDev("LobbieCheckbox - DISABLED. KEEP VALUE -", value);
            return;
        }
        logDev(`LobbieCheckbox - SET ${name} CHECKED TO VALUE -`, !value);
        setValue(name, !value);
    };

    // logDev("LobbieCheckbox - render not-useForm checkbox");
    return (
        <Form.Label
            className={`checkbox-container ${rest.className || ""}`}
            style={{
                ...style,
                opacity: rest.disabled ? "50%" : "100%",
            }}
            data-disabled={rest.disabled ? true : undefined}
        >
            <input
                ref={ref}
                className={"lobbie-checkbox"}
                id={name}
                type={"checkbox"}
                checked={Boolean(value)}
                readOnly={true}
                disabled={rest.disabled ? true : undefined}
            />

            <span
                onClick={handleSetChecked}
                className="checkmark"
                data-disabled={rest.disabled ? true : undefined}
                style={checkmarkStyle}
            ></span>
            {typeof label === "string" || typeof label === "number" ? (
                <span onClick={handleSetChecked} data-disabled={rest.disabled ? true : undefined}>
                    {label}
                </span>
            ) : (
                label
            )}
        </Form.Label>
    );
});

export default LobbieCheckbox;
